import { Interface } from '@ethersproject/abi'
import BOOSTED_STAKING_REWARDS_ABI  from './boosted_staking_rewards.json'

const BOOSTED_STAKING_REWARDS_INTERFACE = new Interface(BOOSTED_STAKING_REWARDS_ABI)

export { BOOSTED_STAKING_REWARDS_INTERFACE }
